/* eslint-disable-next-line */
export const GET_TOURNAMENTS = 'GET_TOURNAMENTS'
